<template>
  <div class="dataDirectory">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <!-- 标题 -->
        <span style="font-size: 24px" class="font-sz24">{{ $t('资料管理.资料管理') }}</span>
      </div>
      <el-container>
        <el-card style="width: 65%;">
          <div slot="header">
            <span>{{ $t('资料管理.资料目录树') }}</span>
          </div>
          <el-row>
            <!-- 目录树 -->
            <el-col :span="6">
              <!-- 功能按钮 -->
              <el-button @click="batchAddFile = true" type="primary" size="small">{{ $t('资料管理.资料目录导入') }}</el-button>
              <el-button @click="exportExcel" type="success" size="small">{{ $t('资料管理.资料目录导出') }}</el-button>
              <div style="margin-top: 20px;">
                <el-aside width="220px"
                  style="border: 1px solid #dcdfe6;border-radius: 4px;text-align: center;height: 65vh;" class="elAside">
                  <!-- <el-button type="primary" size="small" @click="showAll">显示全部目录</el-button> -->
                  <div class="zTreeDiv">
                    <ul id="ProjectFileTree" class="ztree"></ul>
                  </div>
                  <div id="ProjectFileRemenu">
                    <ul>
                      <li id="addProjectFile">{{ $t('common.添加') }}</li>
                      <li id="updateProjectFile">{{ $t('common.修改') }}</li>
                      <li id="delProjectFile">{{ $t('common.删除') }}</li>
                      <li id="visibleProjectFile">{{ $t('资料管理.设置') }}</li>
                    </ul>
                  </div>
                </el-aside>
              </div>
            </el-col>
            <!-- 表格 -->
            <el-col :span="18">
              <el-main>
                <el-table ref="singleTable" :data="inform2" highlight-current-row
                  style="width: 100%; margin-bottom: 20px" height="68vh" row-key="ID" border :tree-props="{
                    children: 'children',
                    hasChildren: 'hasChildren',
                  }">
                  <el-table-column align="center" property="label" :label="$t('资料管理.名称')"></el-table-column>
                  <el-table-column align="center" property="Count" :label="$t('资料管理.文件数量')"></el-table-column>
                  <el-table-column align="center" property="user" :label="$t('资料管理.维护人员')"></el-table-column>
                  <el-table-column align="center" property="DateTime" :label="$t('资料管理.更新时间')"></el-table-column>
                </el-table>

                <el-table :data="inform" style=" margin-bottom: 20px" height="72vh" v-show="daochu" class="daochu">
                  <el-table-column label="Id" align="center" prop="ID"></el-table-column>
                  <el-table-column align="center" prop="label" label="名称"></el-table-column>
                  <el-table-column label="父节点" align="center" prop="ParentId"></el-table-column>
                  <el-table-column label="备注" align="center" prop="Content"></el-table-column>
                  <el-table-column label="排序" align="center" prop="order"></el-table-column>
                </el-table>
              </el-main>
            </el-col>
          </el-row>


        </el-card>
        <el-card style="width: 34%;margin-left: 1%;">
          <div slot="header">
            <span>{{ $t('资料管理.资料标签') }}</span>
          </div>
          <el-row>
            <!-- 目录树 -->
            <el-col :span="24">
              <div style="margin-top: 20px;">
                <el-aside width="220px"
                  style="border: 1px solid #dcdfe6;border-radius: 4px;text-align: center;height: 65vh;" class="elAside">
                  <div class="zTreeDiv">
                    <ul id="fileLabelTree" class="ztree"></ul>
                  </div>
                  <div id="fileLabelRemenu">
                    <ul>
                      <li id="addfileLabel">{{ $t('common.添加') }}</li>
                      <li id="updatefileLabel">{{ $t('common.修改') }}</li>
                      <li id="delfileLabel">{{ $t('common.删除') }}</li>
                    </ul>
                  </div>
                </el-aside>
              </div>
            </el-col>
          </el-row>


        </el-card>

      </el-container>
    </el-card>
    <!-- 批量文件添加节点 -->
    <el-dialog :close-on-click-modal="false" title="导入节点" :visible.sync="batchAddFile" width="40%" center>
      <p style="margin-bottom: 10px;">
        {{ $t('人员管理.点击下载模板文件') }}：
        <a style="color: red" class="cor-red" :href="$store.state.baseUrl + '/UploadFiles/资料目录树.xlsx'"
          target="_blank">示例表格.XLSX</a>{{ $t('人员管理.并按要求填好后上传') }}
      </p>

      <el-upload ref="upload" class="upload-demo" :action="actionUrl" :on-change="handleChange" :file-list="fileList"
        :limit="1" :data="nodeFileData" :before-upload="beforeUpload" accept=".xlsx" :auto-upload="false"
        :on-success="uploadSuccess" :headers="importHeaders" :on-exceed="handleExceed">
        <el-button slot="trigger" size="small" type="primary">{{ $t('人员管理.选择文件') }}</el-button>
        <el-button style="margin-left: 10px" class="mar-left10" size="small" type="success" @click="submitUpload">{{
          $t('人员管理.上传到服务器') }}</el-button>
        <div slot="tip" class="el-upload__tip">{{ $t('人员管理.只能上传xlsx文件') }}</div>
      </el-upload>
    </el-dialog>

    <!-- 人员选择 -->
    <el-dialog :close-on-click-modal="false" :title="$t('资料管理.设置可见人员审核')" :visible.sync="visibleProjectFileShow"
      width="80%" center>
      <el-container>
        <!-- 这里是侧边栏-->
        <div style="margin-top: 20px">
          <el-aside width="200px" style="
              border: 1px solid #dcdfe6;
              border-radius: 4px;
              text-align: center;
            " class="elAside">
            <el-button type="primary" size="small" @click="showAll2">{{ $t('资料管理.显示全部人员') }}</el-button>
            <div class="zTreeDiv">
              <ul id="PdeptTree" class="ztree" style="height: 700px"></ul>
            </div>
          </el-aside>
        </div>
        <!-- 这里是内容显示区域 -->

        <el-main>
          <el-row type="flex" style="padding: 5px 20px">
            <el-col class="middle" :span="6">{{ $t('资料管理.当前节点是否需要审核') }}：</el-col>
            <el-col :span="6">
              <el-radio-group v-model="selectNode.pftr10">
                <el-radio label="1" border>{{ $t('资料管理.是') }}</el-radio>
                <el-radio label="0" border>{{ $t('资料管理.否') }}</el-radio>
              </el-radio-group>
            </el-col>
          </el-row>
          <el-row type="flex" style="padding: 5px 20px">
            <el-col class="middle" :span="3">{{ $t('资料管理.已选择人员') }}：</el-col>
            <el-col :span="20">
              <el-select v-model="selectUserIds" multiple filterable clearable style="width: 100%"
                @remove-tag="delSelectUser" @change="changeSelectUser" :placeholder="$t('资料管理.不选择为全部可见')">
                <el-option v-for="item in allUsers" :key="item.value" :label="item.user04" :value="item.user01">
                </el-option> </el-select>
            </el-col>
            <el-col :span="1" :offset="1">
              <el-button type="success" @click="submitVisibleUser">{{ $t('资料管理.提交') }}</el-button>
            </el-col>
          </el-row>


          <div class="rygl-table">
            <el-table class="margin-20 table" v-loading="loading" :data="communication" height="72vh"
              style="width: 100%" @selection-change="handleSelectionChange">
              <el-table-column align="center" type="selection" width="55"></el-table-column>
              <el-table-column type="index" align="center" :label="$t('资料管理.序号')" width="80"></el-table-column>
              <el-table-column align="center" prop="user02" :label="$t('资料管理.账号')"></el-table-column>
              <el-table-column align="center" prop="user04" :label="$t('资料管理.姓名')"></el-table-column>
              <el-table-column align="center" prop="prde03" :label="$t('资料管理.所属组织')"></el-table-column>
              <el-table-column align="center" prop="pror02" :label="$t('资料管理.岗位')"></el-table-column>
              <el-table-column align="center" prop="user12" :label="$t('资料管理.邮箱')">
                <template slot-scope="scope">{{
                  ($store.state.permissions != null &&
                    !$store.state.permissions.includes("1012")) ||
                    $store.state.isProject
                    ? scope.row.user12
                    : "**************"
                }}
                </template>
              </el-table-column>
              <el-table-column align="center" prop="user11" :label="$t('资料管理.手机号')">
                <template slot-scope="scope">{{
                  ($store.state.permissions != null &&
                    !$store.state.permissions.includes("1011")) ||
                    $store.state.isProject
                    ? scope.row.user11
                    : "**************"
                }}</template>
              </el-table-column>
            </el-table>
          </div>
          <div>
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" align="center"
              style="margin-top: 30px" :current-page="pagenum" :page-sizes="[10, 50, 100]" :page-size="pagesize"
              layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
          </div>
        </el-main>
      </el-container>
    </el-dialog>
  </div>
</template>

<script>
// excel导出
import FileSaver from "file-saver";
import XLSX from "xlsx";
import {
  GetProjectFileTree,
  GetProjectFileZTree,
  AddProjectFile,
  EditProjectFile,
  DelProjectFile,
  ChangeProjectFileOrder,
  FindProjectFileInfo,
  GetDeptUser,
  GetProjectdeptZTree,
  submitVisibleUser,
  GetFileLabel,
  SetFileLabel,
  DeleteFileLabel,
  ChangeFileLebalOrder
} from "@/setAxios.js";
export default {
  name: "ProjectInformation",
  data() {
    return {
      //#region 资料目录树
      //人员显示开始----
      loading: false,
      pagesize: 10,
      pagenum: 1,
      total: 0,
      menuData: [],
      communication: [],
      zTeeObj2: null,
      ids2: "null",
      visibleProjectFileShow: false,
      allUsers: [],
      selectUsers: [],
      selectUserIds: [],
      //人员显示结束----
      daochu: false,
      actionUrl: this.$store.state.baseUrl + "/api/ImportDataExcel",
      importHeaders: { token: localStorage.getItem("token") },
      fileList: [],
      nodeFileData: {
        projectId: localStorage.xid,
        uid: localStorage.id,
      },
      batchAddFile: false,
      inform: [],
      inform2: [],
      tableLoading: false,
      ids: "null",
      zNodes: null,
      selectNode: {},
      selectNodes: [],
      zTeeObj: null,
      //#endregion

      //#region 资料标签
      filelabelData: [],
      fileLabelzTreeObj: null,
      selectLabelNode: {}
      //#endregion
    };
  },
  methods: {
    //#region 资料目录树
    //人员显示开始--------------------------------------
    //去重
    unique(arr, val) {
      const res = new Map();
      return arr.filter((item) => !res.has(item[val]) && res.set(item[val], 1));
    },
    submitVisibleUser() {
      if (this.selectNodes.length > 1) {
        this.$confirm(
          "检测到当前资料目录节点下有子节点，当前设置是否应用子节点?",
          "提示",
          {
            confirmButtonText: "是",
            cancelButtonText: "否",
            type: "warning",
          }
        )
          .then(() => {
            this.submitVisibleUserAxios();
          })
          .catch(() => {
            this.selectNodes = [this.selectNodes[0]];
            this.submitVisibleUserAxios();
          });
      } else {
        this.submitVisibleUserAxios();
      }
    },
    submitVisibleUserAxios() {
      let params = {
        fids: this.selectNodes.join(","),
        uids: this.selectUserIds.length ? this.selectUserIds.join(",") : null,
        pftr10: this.selectNode.pftr10,
      };
      submitVisibleUser(params).then((res) => {
        if (res.Code) {
          this.$message.success("修改成功");
          this.visibleProjectFileShow = false;
          this.selectNodes = [];
          this.selectUserIds = [];
          this.selectUsers = [];
          this.GetProjectFileZTree();
        }
      });
    },
    changeSelectUser(data) {
      this.selectUsers = this.allUsers.filter((x) => data.includes(x.user01));
      this.selectUserIds = this.selectUsers.map((item) => item.user01);
    },
    delSelectUser(data) {
      this.selectUsers = this.selectUsers.filter((x) => x.user01 != data);
      this.selectUserIds = this.selectUsers.map((item) => item.user01);
    },
    handleSelectionChange(ids) {
      this.selectUsers = this.selectUsers.concat(ids);
      this.selectUsers = this.unique(this.selectUsers, "user01");
      this.selectUserIds = this.selectUsers.map((item) => item.user01);
    },
    showAll2() {
      this.ids2 = "null";
      this.GetDeptUser();
    },
    //初始化ztree
    init2() {
      var _this = this;
      var setting = {
        view: {
          selectedMulti: false,
        },
        check: {
          enable: true,
        },
        data: {
          key: {
            name: "prde03",
          },
          simpleData: {
            enable: true,
            idKey: "prde01",
            pIdKey: "prde07",
          },
        },
        callback: {
          onCheck: onCheck,
          onClick: onclick,
        },
      };
      this.zTeeObj2 = $.fn.zTree.init($("#PdeptTree"), setting, this.menuData);

      this.zTeeObj2.checkAllNodes(true);

      var checkedNodes = this.zTeeObj2.getCheckedNodes();
      _this.ids2 = "";
      var _split = "";
      checkedNodes.forEach((element) => {
        _this.ids2 += _split + element.prde01;
        _split = ",";
      });
      _this.GetDeptUser();
      // 选中状态
      function onCheck() {
        var checkedNodes = _this.zTeeObj2.getCheckedNodes();
        _this.ids2 = "";
        var _split = "";
        checkedNodes.forEach((element) => {
          _this.ids2 += _split + element.prde01;
          _split = ",";
        });
        _this.GetDeptUser();
      }
      //点击事件
      function onclick(event, treeId, treeNode) {
        _this.pagenum = 1;
        _this.ids2 = treeNode.prde01;
        _this.GetDeptUser();
      }
    },

    handleNodeClick(data) {
      this.pagenum = 1;
      this.bid = data.ID;
      this.GetDeptUser();
    },
    handleSizeChange(val) {
      this.pagesize = val;
      this.GetDeptUser();
    },
    handleCurrentChange(val) {
      this.pagenum = val;
      this.GetDeptUser();
    },
    getData2() {
      let params = {
        id: localStorage.getItem("xid"),
      };
      GetProjectdeptZTree({ params }).then((res) => {
        this.menuData = res.Data;
        this.init2();
      });
    },
    GetDeptUser() {
      this.loading = true;
      let params = {
        xid: localStorage.getItem("xid"),
        bid: this.ids2,
        cid: localStorage.getItem("pid"),
        pageIndex: this.pagenum,
        pageSize: this.pagesize,
      };
      GetDeptUser({ params }).then((res) => {
        this.loading = false;
        this.total = res.Data.total;
        this.communication = res.Data.list;
      });
    },
    getAllUser() {
      let params = {
        xid: localStorage.getItem("xid"),
        bid: "null",
        cid: localStorage.getItem("pid"),
        pageIndex: 1,
        pageSize: 99999,
      };
      GetDeptUser({ params }).then((res) => {
        this.allUsers = res.Data.list;
      });
    },
    //人员显示结束--------------------------------------
    // 导出表格所用
    exportExcel() {
      this.daochu = true;
      // 设置当前日期
      let time = new Date();
      let year = time.getFullYear();
      let month = time.getMonth() + 1;
      let day = time.getDate();
      let name = year + "" + month + "" + day;
      var wb = XLSX.utils.table_to_book(document.querySelector(".daochu"));
      var wbout = XLSX.write(wb, {
        bookType: "xlsx",
        bookSST: true,
        type: "array",
      });
      try {
        FileSaver.saveAs(
          new Blob([wbout], { type: "application/octet-stream" }),
          name + ".xlsx"
        );
      } catch (e) { }
      this.daochu = false;
      return wbout;
    },
    submitUpload() {
      if (this.fileList.length > 0) {
        this.$refs.upload.submit();
      } else {
        this.$message({
          type: "warning",
          message: "请选择文件后上传",
        });
      }
    },
    handleChange(file, fileList) {
      this.fileList = fileList.slice(-3);
    },
    beforeUpload(file) {
      let fd = new FormData();
      fd.append("file", file);
      fd.append("nodeFileData", JSON.stringify(this.nodeFileData));
      var index = file.name.lastIndexOf(".");
      var suffix = file.name.substring(index + 1);
      const extension = suffix === "xlsx";
      //(suffix);
      if (!extension) {
        this.$message({
          message: this.$t('人员管理.只能上传xlsx文件'),
          type: "warning",
        });
        this.loading2 = false;
      }
      return extension;
    },
    // 上传成功
    uploadSuccess(data) {
      this.loading2 = false;
      this.updataModel1 = false;
      if (data.Code > 0) {
        this.$message({
          type: "success",
          message: this.$t('common.处理成功')
        });
        this.modelList();
      } else {
        this.$message({
          type: "warning",
          message: this.$t('common.处理失败')
        });
      }
    },
    handleExceed(files, fileList) {
      this.$message.error(this.$t('common.只能选择一个'));
    },
    showAll() {
      this.zTeeObj.checkAllNodes(true);
      var checkedNodes = this.zTeeObj.getCheckedNodes();
      this.ids = "";
      var _split = "";
      checkedNodes.forEach((element) => {
        this.ids += _split + element.pftr01;
        _split = ",";
      });
      this.getData();
    },
    //初始化ztree
    init() {
      var _this = this;
      var setting = {
        view: {
          selectedMulti: false,
        },
        check: {
          enable: true,
        },
        data: {
          key: {
            name: "pftr02",
          },
          simpleData: {
            enable: true,
            idKey: "pftr01",
            pIdKey: "pftr03",
          },
        },
        edit: {
          enable: true,
          showRemoveBtn: false,
          showRenameBtn: false,
          drag: {
            isMove: true,
            inner: true,
            prev: false,
            next: true,
          },
        },
        callback: {
          onRightClick: OnRightClick,
          beforeRename: beforeRename,
          beforeDrop: beforeDrop,
          onCheck: onCheck,
          onClick: onclick,
        },
      };

      this.zTeeObj = $.fn.zTree.init(
        $("#ProjectFileTree"),
        setting,
        this.zNodes
      );
      this.zTeeObj.checkAllNodes(true);
      var checkedNodes = this.zTeeObj.getCheckedNodes();
      _this.ids = "";
      var _split = "";
      checkedNodes.forEach((element) => {
        _this.ids += _split + element.pftr01;
        _split = ",";
      });
      _this.getData();
      // 选中状态
      function onCheck() {
        var checkedNodes = _this.zTeeObj.getCheckedNodes();
        _this.ids = "";
        var _split = "";
        checkedNodes.forEach((element) => {
          _this.ids += _split + element.pftr01;
          _split = ",";
        });
        _this.getData();
      }
      // 拖拽功能
      function beforeDrop(treeId, treeNodes, targetNode, moveType) {
        var moveNode = treeNodes[0];
        switch (moveType) {
          case "prev":
          case "next":
          case "inner":
            ChangeProjectFileOrder({
              oid: moveNode.pftr01,
              nid: targetNode.pftr01,
              moveType: moveType,
            });
            _this.$message({
              type: "success",
              message: _this.$t('common.处理成功')
            });
            return true;
            break;
        }
        return false;
      }
      //点击事件
      function onclick(event, treeId, treeNode) {
        _this.ids = treeNode.pftr01;
        _this.getData();
      }
      function getChildren(ids, treeNode) {
        ids.push(treeNode.pftr01);
        if (treeNode.isParent) {
          for (var obj in treeNode.children) {
            getChildren(ids, treeNode.children[obj]);
          }
        }
        return ids;
      }
      // 在ztree上的右击事件
      function OnRightClick(event, treeId, treeNode) {
        _this.selectNode = treeNode;
        _this.selectNodes = [];
        if (treeNode) {
          _this.selectNode.pftr10 = treeNode.pftr10 + "";
          _this.selectNodes = getChildren(_this.selectNodes, treeNode);
        }
        if (treeNode == null) {
          showRMenu("root", event.clientX, event.clientY);
        } else {
          showRMenu("node", event.clientX, event.clientY);
        }
      }
      //鼠标按下事件
      function onBodyMouseDown(event) {
        if (
          !(
            event.target.id == "ProjectFileRemenu" ||
            $(event.target).parents("#ProjectFileRemenu").length > 0
          )
        ) {
          $("#ProjectFileRemenu").css({ visibility: "hidden" });
        }
      }
      //显示右键菜单
      function showRMenu(type, x, y) {
        if (type == "root") {
          $("#addProjectFile").show();
          $("#updateProjectFile").hide();
          $("#delProjectFile").hide();
          $("#visibleProjectFile").hide();
        } else {
          $("#addProjectFile").show();
          $("#updateProjectFile").show();
          $("#delProjectFile").show();
          $("#visibleProjectFile").show();
        }
        $("#ProjectFileRemenu").show();
        $("#ProjectFileRemenu").css({
          top: y + "px",
          left: x + "px",
          visibility: "visible",
        }); //设置右键菜单的位置、可见
        $("body").bind("mousedown", onBodyMouseDown);
      }

      $("#ProjectFileRemenu ul li")
        .unbind()
        .bind("click", function () {
          $("#ProjectFileRemenu").css({
            visibility: "hidden",
          });
          var type = $(this).attr("id");
          if (type == "addProjectFile") {
            var newNode = {},
              params = {};
            params = {
              pftr01: 0,
              pftr02: _this.$t('common.新建节点'),
              pftr03: _this.selectNode == null ? 0 : _this.selectNode.pftr01,
              pftr04: localStorage.getItem("xid"),
              pftr05: new Date(),
              pftr07: localStorage.id,
            };
            AddProjectFile(params).then((res) => {
              if (res.Code > 0) {
                _this.$message({
                  type: "success",
                  message: _this.$t('common.处理成功'),
                });
                newNode = res.Data;
                _this.zTeeObj.addNodes(_this.selectNode, newNode);
                var currentNode = _this.zTeeObj.getNodeByParam(
                  "pftr01",
                  newNode.pftr01
                );
                _this.zTeeObj.selectNode(currentNode);
                _this.zTeeObj.editName(currentNode);
              } else {
                _this.$message({
                  type: "waring",
                  message: _this.$t('common.处理失败')
                });
              }
            });
          } else if (type == "delProjectFile") {
            _this.$confirm(_this.$t('common.删除询问')).then((_) => {
              var treeNodes = _this.zTeeObj.transformToArray(_this.selectNode);
              var ids = "",
                _split = "";
              treeNodes.forEach((element) => {
                ids += _split + element.pftr01;
                _split = ",";
              });
              let params = { xid: localStorage.getItem("xid"), zid: ids };
              DelProjectFile(params).then((res) => {
                if (res.Code > 0) {
                  _this.$message({
                    type: "success",
                    message: _this.$t('common.处理成功'),
                  });
                  var currentNode = _this.zTeeObj.getNodeByParam(
                    "pftr01",
                    _this.selectNode.pftr01
                  );
                  _this.zTeeObj.removeNode(currentNode);
                } else {
                  _this.$message({
                    type: "warning",
                    message: _this.$t('common.处理失败'),
                  });
                }
              });
            });
          } else if (type == "visibleProjectFile") {
            _this.getData2();
            if (_this.selectNode.pftr09) {
              let uids = _this.selectNode.pftr09.split(",").map(Number);
              _this.selectUsers = _this.allUsers.filter((x) =>
                uids.includes(x.user01)
              );
              _this.selectUserIds = _this.selectUsers.length
                ? _this.selectUsers.map((item) => item.user01)
                : [];
            }
            _this.visibleProjectFileShow = true;
          } else {
            _this.zTeeObj.editName(_this.selectNode);
          }
        });

      function beforeRename(treeId, treeNode, newName, isCancel) {
        if (newName != treeNode.pftr02) {
          let params = {
            zid: treeNode.pftr01,
            name: newName,
          };
          EditProjectFile(params).then((res) => {
            _this.$message({
              type: "success",
              message: _this.$t('common.处理成功'),
            });
          });
        }
      }
    },
    // 获取所有数据
    getData() {
      let params = {
        zid: this.ids,
      };
      this.tableLoading = true;
      FindProjectFileInfo(params).then((res) => {
        this.tableLoading = false;
        this.inform = res.Data;
        this.inform2 = this.buildTree(res.Data);
      });
    },
    buildTree(flatData) {
      const map = {};
      const tree = [];

      flatData.forEach(item => {
        map[item.ID] = { ...item, children: [] }; //  id 字段
      });

      flatData.forEach(item => {
        if (item.ParentId && map[item.ParentId]) { //  parent id 字段
          map[item.ParentId].children.push(map[item.ID]);
        } else {
          tree.push(map[item.ID]);
        }
      });

      return tree;
    },
    GetProjectFileZTree() {
      let params = {
        xid: localStorage.getItem("xid"),
        all: true,
      };
      GetProjectFileZTree({ params }).then((res) => {
        this.zNodes = res.Data || [];
        this.zNodes.forEach(v => {
          v.iconSkin = "pIcon04"
        })
        this.init();
      });
    },
    //#endregion

    //#region 资料标签

    GetFileLabel() {
      let params = { xid: localStorage.getItem("xid") }
      GetFileLabel({ params }).then(res => {
        this.filelabelData = res.Data
        this.initFileLabelTree();
      })
    },
    //初始化ztree
    initFileLabelTree() {
      var _this = this;
      var setting = {
        view: {
          selectedMulti: false,
        },
        check: {
          enable: false,
        },
        data: {
          key: {
            name: "name",
          },
          simpleData: {
            enable: true,
            idKey: "id",
            pIdKey: "parentId",
          },
        },
        edit: {
          enable: true,
          showRemoveBtn: false,
          showRenameBtn: false,
          drag: {
            isMove: true,
            inner: true,
            prev: false,
            next: true,
          },
        },
        callback: {
          onRightClick: OnRightClick,
          beforeRename: beforeRename,
          beforeDrop: beforeDrop,
          // onCheck: onCheck,
          // onClick: onclick,
        },
      };
      this.fileLabelzTreeObj = $.fn.zTree.init(
        $("#fileLabelTree"),
        setting,
        this.filelabelData
      );
      // _this.fileLabelzTreeObj.checkAllNodes(true);
      // var checkedNodes = _this.fileLabelzTreeObj.getCheckedNodes();
      // _this.ids = "";
      // var _split = "";
      // checkedNodes.forEach((element) => {
      //   _this.ids += _split + element.pftr01;
      //   _split = ",";
      // });
      // _this.getData();
      // 选中状态
      // function onCheck() {
      //   var checkedNodes = _this.zTeeObj.getCheckedNodes();
      //   _this.ids = "";
      //   var _split = "";
      //   checkedNodes.forEach((element) => {
      //     _this.ids += _split + element.pftr01;
      //     _split = ",";
      //   });
      //   _this.getData();
      // }
      // 拖拽功能
      function beforeDrop(treeId, treeNodes, targetNode, moveType) {
        var moveNode = treeNodes[0];
        switch (moveType) {
          case "prev":
          case "next":
          case "inner":
            ChangeFileLebalOrder({
              oid: moveNode.id,
              nid: targetNode.id,
              moveType: moveType,
            });
            _this.$message({
              type: "success",
              message: _this.$t('common.处理成功'),
            });
            return true;
        }
        return false;
      }
      //点击事件
      // function onclick(event, treeId, treeNode) {
      //   _this.ids = treeNode.pftr01;
      //   _this.getData();
      // }
      // function getChildren(ids, treeNode) {
      //   ids.push(treeNode.pftr01);
      //   if (treeNode.isParent) {
      //     for (var obj in treeNode.children) {
      //       getChildren(ids, treeNode.children[obj]);
      //     }
      //   }
      //   return ids;
      // }
      // 在ztree上的右击事件
      function OnRightClick(event, treeId, treeNode) {
        _this.selectLabelNode = treeNode;
        // _this.selectNodes = [];
        // if (treeNode) {
        //   _this.selectNode.pftr10 = treeNode.pftr10 + "";
        //   _this.selectNodes = getChildren(_this.selectNodes, treeNode);
        // }
        if (treeNode == null) {
          showRMenu("root", event.clientX, event.clientY);
        } else {
          showRMenu("node", event.clientX, event.clientY);
        }
      }
      //鼠标按下事件
      function onBodyMouseDown(event) {
        if (
          !(
            event.target.id == "fileLabelRemenu" ||
            $(event.target).parents("#fileLabelRemenu").length > 0
          )
        ) {
          $("#fileLabelRemenu").css({ visibility: "hidden" });
        }
      }
      //显示右键菜单
      function showRMenu(type, x, y) {
        if (type == "root") {
          $("#addfileLabel").show();
          $("#updatefileLabel").hide();
          $("#delfileLabel").hide();
        } else {
          $("#addfileLabel").show();
          $("#updatefileLabel").show();
          $("#delfileLabel").show();
        }
        $("#fileLabelRemenu").show();
        $("#fileLabelRemenu").css({
          top: y + "px",
          left: x + "px",
          visibility: "visible",
        }); //设置右键菜单的位置、可见
        $("body").bind("mousedown", onBodyMouseDown);
      }

      $("#fileLabelRemenu ul li")
        .unbind()
        .bind("click", function () {
          $("#fileLabelRemenu").css({
            visibility: "hidden",
          });
          var type = $(this).attr("id");
          if (type == "addfileLabel") {
            var newNode = {},
              params = {};
            params = {
              id: 0,
              name: _this.$t('common.新建节点'),
              parentid: _this.selectLabelNode == null ? 0 : _this.selectLabelNode.id,
              xid: localStorage.getItem("xid")
            };
            SetFileLabel(params).then((res) => {
              if (res.Code > 0) {
                _this.$message({
                  type: "success",
                  message: _this.$t('common.处理成功'),
                });
                newNode = res.Data;
                _this.fileLabelzTreeObj.addNodes(_this.selectLabelNode, newNode);
                var currentNode = _this.fileLabelzTreeObj.getNodeByParam(
                  "id",
                  newNode.id
                );
                _this.fileLabelzTreeObj.selectNode(currentNode);
                _this.fileLabelzTreeObj.editName(currentNode);
              } else {
                _this.$message({
                  type: "warning",
                  message: _this.$t('common.处理失败'),
                });
              }
            });
          } else if (type == "delfileLabel") {
            _this.$confirm(_this.$t('common.删除询问')).then((_) => {
              DeleteFileLabel({ id: _this.selectLabelNode.id }).then((res) => {
                if (res.Code > 0) {
                  _this.$message({
                    type: "success",
                    message: _this.$t('common.处理成功'),
                  });
                  var currentNode = _this.fileLabelzTreeObj.getNodeByParam(
                    "id",
                    _this.selectLabelNode.id
                  );
                  _this.fileLabelzTreeObj.removeNode(currentNode);
                } else {
                  _this.$message({
                    type: "warning",
                    message: _this.$t('common.处理失败'),
                  });
                }
              });
            });
          } else {
            _this.fileLabelzTreeObj.editName(_this.selectLabelNode);
          }
        });

      function beforeRename(treeId, treeNode, newName, isCancel) {
        if (newName != treeNode.name) {
          treeNode.name = newName
          let params = treeNode
          SetFileLabel(params).then((res) => {
            _this.$message({
              type: "success",
              message: _this.$t('common.处理成功'),
            });
          });
        }
      }
    },

    //#endregion

  },
  created() { },
  mounted() {
    this.GetProjectFileZTree();
    this.GetFileLabel();
    this.getAllUser();
  },
};
</script>

<style lang="less" scoped>
.middle {
  display: flex;
  // justify-content: center; /*主轴上居中*/
  align-items: center;
  /*侧轴上居中*/
}

div#ProjectFileRemenu {
  position: fixed;
  visibility: hidden;
  top: 0;
  // width: 40px;
  background-color: #6aa8c7;
  padding: 4px;
  border-radius: 8px;
  overflow: auto;
  border: 1px solid #eee;
}

div#ProjectFileRemenu ul {
  margin: 0px;
  padding: 0px;
}

div#ProjectFileRemenu ul li {
  font-size: 12px;
  line-height: 20px;
  margin: 0px;
  padding: 0px;
  cursor: pointer;
  list-style: none outside none; //取消样式
  background-color: rgba(255, 255, 255, 0);
  padding-left: 3px;
  margin: 1px auto;
  color: white;
  border-radius: 3px;
  letter-spacing: 1px;
}

div#ProjectFileRemenu ul li:hover {
  background: #eee;
  color: #000000;
}


div#fileLabelRemenu {
  position: fixed;
  visibility: hidden;
  top: 0;
  width: 40px;
  background-color: #6aa8c7;
  padding: 4px;
  border-radius: 8px;
  overflow: auto;
  border: 1px solid #eee;
}

div#fileLabelRemenu ul {
  margin: 0px;
  padding: 0px;
}

div#fileLabelRemenu ul li {
  font-size: 12px;
  line-height: 20px;
  margin: 0px;
  padding: 0px;
  cursor: pointer;
  list-style: none outside none; //取消样式
  background-color: rgba(255, 255, 255, 0);
  padding-left: 3px;
  margin: 1px auto;
  color: white;
  border-radius: 3px;
  letter-spacing: 1px;
}

div#fileLabelRemenu ul li:hover {
  background: #eee;
  color: #000000;
}


#ProjectFileTree {
  height: 500px;
}

.ztree {
  height: 95%;
}

.zTreeDiv {
  overflow: auto;
  height: 100%;
}

.ztree li span {
  // color: #fff;
  line-height: 21px;
  margin-right: 2px;
}

// 新增
.font-sz24 {
  font-size: 24px;
}

.head-text {
  float: right;
  margin-top: -4px;
}

.float-r {
  float: right;
}

.float-r-mar-r10 {
  float: right;
  margin-right: 10px;
}

.mar-top20 {
  margin-top: 20px;
}

.elAside {
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  text-align: center;
}

.w100-mar-bom20 {
  width: 100%;
  margin-bottom: 20px;
}

.cor-red {
  color: red;
}

.mar-left10 {
  margin-left: 10px;
}
</style>
